import { SvgIcon, SvgIconProps } from "@mui/material";

export const TotalJobsCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "56", height: "56", fill: "none" }}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <rect width="56" height="56" rx="8" fill="#E7FFE4" />
      <path
        opacity="0.14"
        d="M33.6 21.3334H22.4C20.1598 21.3334 19.0397 21.3334 18.184 21.7693C17.4314 22.1528 16.8195 22.7648 16.436 23.5174C16.1909 23.9983 16.0836 24.5628 16.0366 25.3627C16 25.986 16 26.7523 16 27.7334V33.6C16 35.8403 16 36.9604 16.436 37.816C16.8195 38.5687 17.4314 39.1806 18.184 39.5641C19.0397 40 20.1598 40 22.4 40H33.6C35.8402 40 36.9603 40 37.816 39.5641C38.5686 39.1806 39.1805 38.5687 39.564 37.816C40 36.9604 40 35.8403 40 33.6V27.7334C40 26.7523 40 25.986 39.9634 25.3627C39.9164 24.5628 39.8091 23.9983 39.564 23.5174C39.1805 22.7648 38.5686 22.1528 37.816 21.7693C36.9603 21.3334 35.8402 21.3334 33.6 21.3334Z"
        fill="#008B07"
      />
      <path
        d="M16.0366 25.3626L20.9136 29.2642C21.5634 29.784 21.8882 30.0439 22.25 30.2287C22.5709 30.3927 22.9126 30.5125 23.2656 30.585C23.6636 30.6667 24.0796 30.6667 24.9117 30.6667H31.0883C31.9204 30.6667 32.3364 30.6667 32.7344 30.585C33.0874 30.5125 33.4291 30.3927 33.75 30.2287C34.1118 30.0439 34.4366 29.784 35.0864 29.2642L39.9634 25.3626M16.0366 25.3626C16 25.9859 16 26.7522 16 27.7333V33.6C16 35.8402 16 36.9603 16.436 37.816C16.8195 38.5686 17.4314 39.1805 18.184 39.564C19.0397 40 20.1598 40 22.4 40H33.6C35.8402 40 36.9603 40 37.816 39.564C38.5686 39.1805 39.1805 38.5686 39.564 37.816C40 36.9603 40 35.8402 40 33.6V27.7333C40 26.7522 40 25.9859 39.9634 25.3626M16.0366 25.3626C16.0836 24.5627 16.1909 23.9983 16.436 23.5174C16.8195 22.7647 17.4314 22.1528 18.184 21.7693C19.0397 21.3333 20.1598 21.3333 22.4 21.3333H22.6667M39.9634 25.3626C39.9164 24.5627 39.8091 23.9983 39.564 23.5174C39.1805 22.7647 38.5686 22.1528 37.816 21.7693C36.9603 21.3333 35.8402 21.3333 33.6 21.3333H33.3333M22.6667 21.3333V20C22.6667 17.7909 24.4575 16 26.6667 16H29.3333C31.5425 16 33.3333 17.7909 33.3333 20V21.3333M22.6667 21.3333H33.3333"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TotalApplicantsCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "56", height: "56", fill: "none" }}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <rect width="56" height="56" rx="8" fill="#ECEFFD" />
      <path
        opacity="0.2"
        d="M28 28C34.0751 28 39 25.3137 39 22C39 18.6863 34.0751 16 28 16C21.9249 16 17 18.6863 17 22C17 25.3137 21.9249 28 28 28Z"
        fill="#2C4DED"
      />
      <path
        d="M28 28C34.0751 28 39 25.3137 39 22C39 18.6863 34.0751 16 28 16C21.9249 16 17 18.6863 17 22C17 25.3137 21.9249 28 28 28Z"
        fill="#E34444"
        fillOpacity="0.14"
        stroke="#2C4DED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 22V28C17 31.3137 21.9249 34 28 34C34.0751 34 39 31.3137 39 28V22"
        stroke="#2C4DED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 28V34C17 37.3137 21.9249 40 28 40C34.0751 40 39 37.3137 39 34V28"
        stroke="#2C4DED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TotalJobOpeningsCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "56", height: "56", fill: "none" }}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <rect width="56" height="56" rx="8" fill="#F8EBFF" />
      <path
        opacity="0.14"
        d="M36.4853 19.5147C35.7334 18.7628 34.7567 18.3728 33.7717 18.3447C32.7969 18.3169 32.3095 18.303 32.196 18.2744C31.9532 18.2132 32.125 18.2843 31.9099 18.1559C31.8095 18.0959 31.455 17.7611 30.7461 17.0915C30.0296 16.4148 29.0633 16 28 16C26.9368 16 25.9704 16.4148 25.254 17.0915L25.2539 17.0916C24.545 17.7611 24.1905 18.0959 24.09 18.1559C23.875 18.2843 24.0468 18.2132 23.804 18.2744C23.6905 18.303 23.2031 18.3169 22.2283 18.3447L22.2283 18.3447C21.2432 18.3728 20.2665 18.7628 19.5146 19.5147C18.7628 20.2665 18.3728 21.2432 18.3447 22.2283C18.3169 23.2031 18.303 23.6905 18.2744 23.804C18.2131 24.0468 18.2843 23.875 18.1559 24.0901C18.0959 24.1905 17.7611 24.545 17.0915 25.254C16.4148 25.9704 16 26.9368 16 28C16 29.0632 16.4148 30.0296 17.0915 30.746C17.7611 31.455 18.0959 31.8095 18.1559 31.9099C18.2843 32.125 18.2131 31.9532 18.2744 32.196C18.303 32.3095 18.3169 32.7969 18.3447 33.7717C18.3728 34.7568 18.7628 35.7335 19.5146 36.4853C20.2665 37.2372 21.2432 37.6272 22.2283 37.6553C23.203 37.6831 23.6905 37.697 23.804 37.7256C24.0468 37.7868 23.875 37.7157 24.09 37.8441C24.1905 37.9041 24.545 38.2389 25.254 38.9085C25.9704 39.5852 26.9368 40 28 40C29.0633 40 30.0296 39.5851 30.7461 38.9085L30.7464 38.9081C31.4551 38.2388 31.8095 37.9041 31.9099 37.8441C32.125 37.7157 31.9532 37.7868 32.196 37.7256C32.3095 37.697 32.7969 37.6831 33.7717 37.6553C34.7567 37.6272 35.7334 37.2372 36.4853 36.4853C37.2371 35.7335 37.6271 34.7568 37.6552 33.7717C37.683 32.7969 37.6969 32.3095 37.7256 32.1961C37.7868 31.9532 37.7156 32.125 37.8441 31.91C37.904 31.8095 38.2388 31.4551 38.9082 30.7463L38.9085 30.7461C39.5851 30.0296 40 29.0633 40 28C40 26.9367 39.5851 25.9704 38.9085 25.2539L38.9084 25.2539C38.2389 24.545 37.904 24.1905 37.8441 24.09C37.7156 23.875 37.7868 24.0468 37.7256 23.8039C37.6969 23.6905 37.683 23.2031 37.6552 22.2283C37.6271 21.2432 37.2371 20.2665 36.4853 19.5147Z"
        fill="#9D00EC"
      />
      <path
        d="M23.3333 28.6667L25.3452 30.6785C25.8035 31.1369 26.0327 31.366 26.2931 31.4429C26.5218 31.5104 26.7666 31.4993 26.9883 31.4113C27.2406 31.3112 27.4481 31.0623 27.8631 30.5643L33.3333 24M33.7717 18.3447C34.7567 18.3728 35.7334 18.7628 36.4853 19.5147C37.2371 20.2665 37.6271 21.2432 37.6552 22.2283C37.683 23.2031 37.6969 23.6905 37.7256 23.8039C37.7868 24.0468 37.7156 23.875 37.8441 24.09C37.904 24.1905 38.2389 24.545 38.9085 25.2539C39.5851 25.9704 40 26.9367 40 28C40 29.0633 39.5851 30.0296 38.9085 30.7461C38.2389 31.455 37.904 31.8095 37.8441 31.91C37.7156 32.125 37.7868 31.9532 37.7256 32.1961C37.6969 32.3095 37.683 32.7969 37.6552 33.7717C37.6271 34.7568 37.2371 35.7335 36.4853 36.4853C35.7334 37.2372 34.7567 37.6272 33.7717 37.6553C32.7969 37.6831 32.3095 37.697 32.196 37.7256C31.9532 37.7868 32.125 37.7157 31.9099 37.8441C31.8095 37.9041 31.455 38.2389 30.7461 38.9085C30.0296 39.5851 29.0633 40 28 40C26.9368 40 25.9704 39.5852 25.254 38.9085C24.545 38.2389 24.1905 37.9041 24.09 37.8441C23.875 37.7157 24.0468 37.7868 23.804 37.7256C23.6905 37.697 23.203 37.6831 22.2283 37.6553C21.2432 37.6272 20.2665 37.2372 19.5146 36.4853C18.7628 35.7335 18.3728 34.7568 18.3447 33.7717C18.3169 32.7969 18.303 32.3095 18.2744 32.196C18.2131 31.9532 18.2843 32.125 18.1559 31.9099C18.0959 31.8095 17.7611 31.455 17.0915 30.746C16.4148 30.0296 16 29.0632 16 28C16 26.9368 16.4148 25.9704 17.0915 25.254C17.7611 24.545 18.0959 24.1905 18.1559 24.0901C18.2843 23.875 18.2131 24.0468 18.2744 23.804C18.303 23.6905 18.3169 23.2031 18.3447 22.2283C18.3728 21.2432 18.7628 20.2665 19.5146 19.5147C20.2665 18.7628 21.2432 18.3728 22.2283 18.3447C23.2031 18.3169 23.6905 18.303 23.804 18.2744C24.0468 18.2132 23.875 18.2843 24.09 18.1559C24.1905 18.0959 24.545 17.7611 25.254 17.0915C25.9704 16.4148 26.9368 16 28 16C29.0633 16 30.0296 16.4148 30.7461 17.0915C31.455 17.7611 31.8095 18.0959 31.9099 18.1559C32.125 18.2843 31.9532 18.2132 32.196 18.2744C32.3095 18.303 32.7969 18.3169 33.7717 18.3447Z"
        stroke="#9D00EC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SearchInputIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FilterButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const JobMenuButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99984 10.8333C10.4601 10.8333 10.8332 10.4602 10.8332 9.99992C10.8332 9.53968 10.4601 9.16659 9.99984 9.16659C9.5396 9.16659 9.1665 9.53968 9.1665 9.99992C9.1665 10.4602 9.5396 10.8333 9.99984 10.8333Z"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99984 4.99992C10.4601 4.99992 10.8332 4.62682 10.8332 4.16659C10.8332 3.70635 10.4601 3.33325 9.99984 3.33325C9.5396 3.33325 9.1665 3.70635 9.1665 4.16659C9.1665 4.62682 9.5396 4.99992 9.99984 4.99992Z"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99984 16.6666C10.4601 16.6666 10.8332 16.2935 10.8332 15.8333C10.8332 15.373 10.4601 14.9999 9.99984 14.9999C9.5396 14.9999 9.1665 15.373 9.1665 15.8333C9.1665 16.2935 9.5396 16.6666 9.99984 16.6666Z"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CloseJobButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "10", fill: "none" }}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path d="M9 1L1 9M9 9L1 1" stroke={props.stroke ?? "#111111"} strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const ArrowLeftNavigationButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M12.8332 7.00008H1.1665M1.1665 7.00008L6.99984 12.8334M1.1665 7.00008L6.99984 1.16675"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowRightNavigationButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1.1665 7.00008H12.8332M12.8332 7.00008L6.99984 1.16675M12.8332 7.00008L6.99984 12.8334"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ToolTipIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_33143_1606)">
        <path
          d="M6.06016 6.00004C6.2169 5.55449 6.52626 5.17878 6.93347 4.93946C7.34067 4.70015 7.81943 4.61267 8.28495 4.69252C8.75047 4.77236 9.17271 5.01439 9.47688 5.37573C9.78106 5.73706 9.94753 6.19439 9.94683 6.66671C9.94683 8.00004 7.94683 8.66671 7.94683 8.66671M8.00016 11.3334H8.00683M14.6668 8.00004C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00004C1.3335 4.31814 4.31826 1.33337 8.00016 1.33337C11.6821 1.33337 14.6668 4.31814 14.6668 8.00004Z"
          stroke="#98A2B3"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_33143_1606">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
